import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'

import { I18NService } from 'services'

interface FormType {
  companyName: string
  country: string
  governmentId?: string
  subregion: number
}

export const useCreateOrganizationCompanyForm = () => {
  const { t } = useTranslation(I18NService.NAMESPACES.COMMON)

  const validationSchema = yup.object().shape({
    companyName: yup.string().required(t('validations.required')),
    country: yup.string().required(t('validations.required')),
    subregion: yup.number().required(t('validations.required')),
    governmentId: yup.string().required(t('validations.required')),
  })

  return useForm<FormType>({ resolver: yupResolver(validationSchema) })
}
